// @ts-nocheck
import React, {useEffect, useState} from 'react';
import {Naskor} from "../../../../../../js/components/naskor";

require('./style.scss');

export default function Row(props) {
    let position = props.position;
    return (
        <tr key={position.product_attribute_id} className="vtsReleaseTableRow">
            <td>{position.brand_name}</td>
            <td>{position.product_size_name}</td>
            <td>{position.product_attribute_name}</td>
            <td className="text-end">{Naskor.formatPrice(position.vts_price)}</td>
            <td className="text-end">{position.remaining_qty}</td>
            <td className="">
                {position.product_attribute_stock_count > 0 &&
                <input
                    className={"vtsNextOrderQty " + (props.errorPerFlavour[position.product_attribute_id] ? 'err-qty' : '')}
                    name={"flavourQty[" + position.product_attribute_id + "]"}
                    type="number"
                    min={0}
                    onChange={(event) => props.handleChange(position.product_attribute_id, position.remaining_qty, event.currentTarget.value)}
                    title={""+(props.errorPerFlavour[position.product_attribute_id]?props.errorPerFlavour[position.product_attribute_id]:'')}
                    value={props.quantity > 0 ? props.quantity : ''}
                />
                }
                {position.product_attribute_stock_count <= 0 && position.product_attribute_eta &&
                    <input disabled="disabled" value={"ETA: "+position.product_attribute_eta} title="Estimated time of arrival" />
                }
                {position.product_attribute_stock_count <= 0 && !position.product_attribute_eta &&
                    <input disabled="disabled" value={"Out of stock"} />
                }
            </td>
        </tr>
    )
}
